import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StellingScore} from '../../../domain/game';

@Component({
  selector: 'sg-stelling',
  templateUrl: './stelling.component.html',
  styleUrls: ['./stelling.component.scss']
})

export class StellingComponent {

  @Input() randomStelling: number;
  @Output() stellingChange = new EventEmitter<StellingScore>();
  contentScreen = false;

  handelKeuzeSchermAf($event) {
    if ($event != null) {
      this.contentScreen = false;
      this.stellingChange.emit($event);
    } else {
      this.contentScreen = false;
      this.stellingChange.emit(null);
    }
  }

  closePopover() {
    this.stellingChange.emit(null);
  }
}

